module.exports = __webpack_public_path__ + "img/pof.c4b3d571.svg";